import { EqipmentAction, EquipmentActionType } from '../actions/shops.actions';

const initialState: any = {
    list: []
};

export function ArticleReducer(
    state: any = initialState,
    action: EqipmentAction
) {
    switch (action.type) {
        case EquipmentActionType.ADD_ITEM:
            // return [...state, action.payload];
            return {
                ...state,
                list: action.payload
            }
        default:
            return state;
    }
}